import React, { useState, useRef, useEffect } from 'react';

import Form from 'react-bootstrap/Form';

import './BasicQueryCreate.css';
import DropdownQueryLabel from '../../../container/dropdown/dropdown-query-create/DropdownQueryLabel';
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';

const BasicQueryCreate = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return () => clearInterval(timerId);
  }, [tooltipShow]);

  const handleResultBtn = () => {
    const body = {
      "query" : {
        "and": props.andString,
        "or": props.orString,
        "not": props.notString
      },
      "type" : "BASIC",
      "dateRange" : [props.dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"}), props.dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})]
    }

    return props.handleResultBtn("/search/query-content", body, props.resultData);
  }

  return (
    <>
      <div className="queryBoxBg">
        <Form>
          <Form.Group>
            <div className="queryBoxTit">AND</div>
            <Form.Control as="textarea" placeholder="and" value={props.andString} onChange={props.handleAndString} 
              name="textarea" rows={3} id="queryInput"/>
            <div className="queryBoxTit">OR</div>
            <Form.Control as="textarea" placeholder="or" value={props.orString} onChange={props.handleOrString}
              name="textarea" rows={3} id="queryInput"/>
            <div className="queryBoxTit">NOT</div>
            <Form.Control as="textarea" placeholder="not" value={props.notString} onChange={props.handleNotString}
              name="textarea" rows={3} id="queryInput"/>
          </Form.Group>
        </Form>
      </div>
      <div className="queryBox50Btn">
        <a className="button purple" onClick={()=>{handleResultBtn()}}>결과 확인</a>
        &nbsp;
        <DropdownQueryLabel toggle="검색어 저장" handleSaveBtn={(query, label, labelID)=>props.handleSaveBtn('basicQuery', query, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData} />
        <TooltipWithTimer target={tooltipTarget} show={tooltipShow}
          tooltipDirection="top" tooltipText={props.saveTooltip}/>
      </div>
    </>
  )
}

export default BasicQueryCreate;  